import { RadioGroupField } from '@hex/calculators-shared/components';
import { Radio, Flex, tokens } from '@sapphire-react/core';
import React from 'react';
import type { Control } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = {
  control: Control<any>;
  loading?: boolean;
};

export enum PolarQuestion {
  No = '0',
  Yes = '1',
}

export function CoApplicant({ control }: Props) {
  const { t } = useTranslation('affordability');

  const secondaryApplicantInquiryRules = {
    required: t('form.coApplicant.error'),
  };

  return (
    <Flex flexDirection={'column'} gap={tokens.size.spacingMd}>
      <RadioGroupField
        control={control}
        orientation={'horizontal'}
        rules={secondaryApplicantInquiryRules}
        name={'secondaryApplicantExist'}
        data-test-id={'secondary-applicant-exist'}
        label={t('form.coApplicant.label')}
      >
        <Radio value={PolarQuestion.Yes} data-test-id={'secondary-applicant-yes'}>
          {t('yes')}
        </Radio>
        <Radio value={PolarQuestion.No} data-test-id={'secondary-applicant-no'}>
          {t('no')}
        </Radio>
      </RadioGroupField>
    </Flex>
  );
}
